export class routes {
  private static base = '';

  public static get baseUrl(): string {
    return this.base;
  }

  // auth routes *start*

  public static get signIn(): string {
    return this.base + '/signin';
  }
  public static get signUp(): string {
    return this.base + '/signup';
  }
  public static get signIn2(): string {
    return this.base + '/signin-2';
  }
  public static get signIn3(): string {
    return this.base + '/signin-3';
  }
  // auth routes *end*

  // error pages routes *start*

  public static get errorPages(): string {
    return this.baseUrl + '/error-pages';
  }
  public static get error404(): string {
    return this.errorPages + '/error-404';
  }
  public static get error500(): string {
    return this.errorPages + '/error-500';
  }
  // public static get blankPage(): string {
  //   return this.pages + '/blank-page';
  // }

  // error pages routes *ends*

  // core pages routes *start*

  public static get core(): string {
    return this.baseUrl;
  }

  public static get notification(): string {
    return this.base + '/notification';
  }
  public static get notificationList(): string {
    return this.notification + '/notification-list';
  }

  public static get settings(): string {
    return this.core + '/settings';
  }

  // public static get pages(): string {
  //   return this.core + '/pages';
  // }

  // public static get profile(): string {
  //   return this.pages + '/profile';
  // }
  // core pages routes *end*


  //new
  public static get homeUrl(): string {
    return this.base+'/home';
  }

  public static get dashboard(): string {
    return this.homeUrl + '/dashboard';
  }

  // event pages routes *starts*
  public static get events(): string {
    return this.homeUrl + '/events';
  }
  public static get eventList(): string {
    return this.events + '/event-list';
  }
  public static get eventMenu(): string {
    return this.events + '/event-menu';
  }
  public static get eventAgenda(): string {
    return this.eventMenu + '/agenda';
  }
  public static get eventAttendance(): string {
    return this.eventMenu + '/attendance';
  }
  public static get eventClients(): string {
    return this.eventMenu + '/clients';
  }
  public static get eventGallery(): string {
    return this.eventMenu + '/gallery';
  }
  public static get eventChat(): string {
    return this.eventMenu + '/chat';
  }
  public static get eventChatPublic(): string {
    return this.eventChat + '/public';
  }
  public static get eventCertificates(): string {
    return this.eventMenu + '/certificates';
  }

  public static get eventMeetings(): string {
    return this.eventMenu + '/meetings';
  }

  public static get eventTips(): string {
    return this.eventMenu + '/tips';
  }

  public static get markAttendance(): string {
    return this.eventAttendance + '/mark-attendance';
  }
  public static get survey(): string {
    return this.eventMenu + '/survey';
  }
  public static get eventContacts(): string {
    return this.eventMenu + '/contacts';
  }
  public static get eventNotifications(): string {
    return this.eventMenu + '/notifications';
  }
  public static get feedback(): string {
    return this.eventMenu + '/feedback';
  }
  public static get groups(): string {
    return this.eventMenu + '/groups';
  }
  public static get banners(): string {
    return this.eventMenu + '/banners';
  }
  public static get sponsors(): string {
    return this.eventMenu + '/sponsors';
  }
  public static get speakers(): string {
    return this.eventMenu + '/speakers';
  }
  public static get resources(): string {
    return this.eventMenu + '/resources';
  }
  public static get location(): string {
    return this.eventMenu + '/location';
  }
  public static get menuConfig(): string {
    return this.eventMenu + '/mobile-menu';
  }
  // event pages routes *end*

  // contacts pages routes *starts*
  public static get contacts(): string {
    return this.homeUrl + '/contacts';
  }
  public static get contactList(): string {
    return this.contacts + '/contact-list';
  }

  // news pages routes *starts*
  public static get news(): string {
    return this.homeUrl + '/news';
  }
  public static get newsList(): string {
    return this.news + '/news-list';
  }

  // clients pages routes *starts*
  public static get clients(): string {
    return this.homeUrl + '/clients';
  }
  public static get clientsList(): string {
    return this.clients + '/clients-list';
  }
  public static get clientsPendingList(): string {
    return this.clients + '/clients-pending-list';
  }

  // admin pages routes *starts*
  public static get admin(): string {
    return this.homeUrl + '/admin';
  }
  public static get adminList(): string {
    return this.admin + '/admin-list';
  }
  public static get mobileMenus(): string {
    return this.homeUrl + '/menus';
  }

  // other pages routes *start*
  public static get success(): string {
    return this.base + '/success';
  }
  public static get success2(): string {
    return this.base + '/success-2';
  }
  public static get success3(): string {
    return this.base + '/success-3';
  }
}
